import { render } from "./global-footer.vue?vue&type=template&id=5217e80e&ts=true&lang=pug"
import script from "./global-footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./global-footer.vue?vue&type=script&lang=ts&setup=true"

import "./global-footer.vue?vue&type=style&index=0&id=5217e80e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__